import { render } from "./CustomLoginView.vue?vue&type=template&id=35bcb199&scoped=true"
import script from "./CustomLoginView.vue?vue&type=script&lang=js"
export * from "./CustomLoginView.vue?vue&type=script&lang=js"

import "./CustomLoginView.vue?vue&type=style&index=0&id=35bcb199&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bcb199"]])

export default __exports__